@if(showHeader()) {
	<ng-container>
		<div class="header has-subtitle">{{ question.getLabel() + ".title" | translate }}</div>
		@if(isRestrictedInvestor()) {
			<ng-container>
				<div class="subtitle" [innerHTML]="question.getLabel() + '.subtitle_md' | markdownTranslate"></div>
			</ng-container>
		} @else {
			<ng-container>
				<div class="subtitle">{{ "uk_customer_segmentation_appropriateness_test.questions.high_net_worth_investor_description" | translate }}</div>
			</ng-container>
		}
	</ng-container>
}

@if(hasAdditionalText()) {
	<div>
		{{ question.getLabel() + ".text" | translate }}
	</div>
}
@if(question.isSingleChoice()) {
	<ng-container>
		<div class="title" [innerHTML]="question.getLabel() + '.question_md' | markdownTranslate"></div>

		<mat-radio-group
			(change)="onRadioChange($event)"
			name="{{ question.getId() }}"
			class="questions">
			@for (answer of question.getAnswers(); track answer) {
				<mat-radio-button
					value="{{ answer.getId() }}"
					[checked]="answersWithYesLabels.includes(answer.getLabel())">
					<div class="questions__text">
						{{ answer.getAnswer() | translate }}
						@if(isRestrictedInvestor()) {
							<p class="questions__description" [innerHTML]="answer.getLabel() + '.description_md' | markdownTranslate"></p>
						}
					</div>
				</mat-radio-button>
			}
		</mat-radio-group>
	</ng-container>
}

@if(question.isInputField()) {
	<ng-container>
		<div class="additional-question">{{ question.getQuestion() | translate }}</div>
		<div class="additional-question__container">
			<bp-input
				[type]="'number'"
				min="0"
				(input)="onInputValueChange($event)"
				(onFocusOut)="onInputFocusOut($event)"
				[(value)]="question.inputValue"
				[ngClass]="{ inputDisabled: disabled }"
				[disabled]="disabled"
				[placeholder]="placeholderText() | translate"
				[formGroupClass]="false"
				[error]="inputError | translate : [minimumValue]">
			</bp-input>
		</div>
	</ng-container>
}
